import React, { useState } from 'react'; 
import data from '../data';

import GeneralActionDisplay from './GeneralActionDisplay';
import generatePdfDocument from './GeneratePDF';
import InvestigativeActionDisplay from './InvestigativeActionDisplay';
import Quade from './Quade';

const DisplayCharacter = ({
    displayedCharacter, setSelectedView, characters,
    setCharacters, setSavedCharacters,
    setSelectedCharacter, setIsEditing
}) => {

    // character data
    const [generalAbilityPools, setGeneralAbilityPools]
        = useState(displayedCharacter.generalAbilityPools);

    const [generalPowerPools, setGeneralPowerPools]
        = useState(displayedCharacter.generalPowerPools);

    const [pushes, setPushes]
        = useState(displayedCharacter.pushes);

    const [selectedPowerID, setSelectedPowerID] = useState(-1);

    const populateCharacterData = (updatedCharacter) => {
        //TODO: do "list" attributes need to be sorted?
        updatedCharacter.generalAbilityPools = generalAbilityPools;
        updatedCharacter.generalPowerPools = generalPowerPools;
        updatedCharacter.pushes = pushes;

    };

    // update handles

    const handleCharacterSubmit = (e) => {
        // update character
        const editedList = characters.map((oneCharacter) => {
            if (oneCharacter.id === displayedCharacter.id) {
                populateCharacterData(oneCharacter);
            }
            return oneCharacter;
        });
        localStorage.setItem("items", JSON.stringify(editedList));
        setCharacters(editedList);
        setSavedCharacters(editedList);
        setSelectedView("MAIN");
    };

    // display mode
    const [selectedMode, setSelectedMode] = useState("DISPLAY_GENERAL");

    function editCharacter() {
        setIsEditing(true);
        setSelectedCharacter(displayedCharacter);
        setSelectedView("CREATE_EDIT_CHARACTER");
    }

    function findPower(powerID) {
        for (let p in data.mutantPowers) {
            let power = data.mutantPowers[p];
            if (power.id === powerID) {
                return power;
            }
        }
        return null;
    }

    const characterHasGeneralAbility = (ability) => {

        return ability.id in displayedCharacter.generalAbilities && displayedCharacter.generalAbilities[ability.id] > 0;
    };

    const characterHasInvestigativeAbility = (ability) => {

        return ability.id in displayedCharacter.investigativeAbilities && displayedCharacter.investigativeAbilities[ability.id] > 0;
    };

    const characterHasPower = (power) => {

        return power.id in displayedCharacter.powers && displayedCharacter.powers[power.id] > 0;
    };

    const powerIsGeneral = (power) => {
        return !power.isInvestigative && !power.isGRF;
    };

    const powerIsInvestigative = (power) => {
        return power.isInvestigative;
    }
    
    const shouldDisplayPowerGeneral = (power) => {
        return characterHasPower(power) && powerIsGeneral(power);
    }

    const shouldDisplayPowerInvestigative = (power) => {
        return characterHasPower(power) && powerIsInvestigative(power);
    }

    const hasAnyGeneralPowers = () => {
        for (let powerID in displayedCharacter.powers) {
            let powerPoints = displayedCharacter.powers[powerID];
            if (powerPoints < 1) {
                continue;
            }
            let power = findPower(parseInt(powerID));
            if (powerIsGeneral(power)) {
                return true; 
            }
        }
        return false;
    }

    const hasAnyInvestigativePowers = () => {
        for (let powerID in displayedCharacter.powers) {
            let powerPoints = displayedCharacter.powers[powerID];
            if (powerPoints < 1) {
                continue;
            }
            let power = findPower(parseInt(powerID));
            if (powerIsInvestigative(power)) {
                return true;
            }
        }
        return false;
    }

    const hasAnyGeneralAbilities = () => {
        for (let abilityID in displayedCharacter.generalAbilities) {
            let points = displayedCharacter.generalAbilities[abilityID];
            if (points > 0) {
                return true;
            }
        }
        return false;
    }

    const hasAnyInvestigativeAbilities = () => {
        for (let abilityID in displayedCharacter.investigativeAbilities) {
            let points = displayedCharacter.investigativeAbilities[abilityID];
            if (points > 0) {
                return true;
            }
        }
        return false;
    }

    // loading ui for rows


    const generalAbilityRows = data.generalAbilities.filter(characterHasGeneralAbility).map(
        item => {
            return (<GeneralActionDisplay
                
                key={item.id}
                item={item}
                character={displayedCharacter}
                generalPools={generalAbilityPools}
                setGeneralPools={setGeneralAbilityPools}
                isPowers={false}
            />)
        }
    );

    const generalPowerRows = data.mutantPowers.filter(shouldDisplayPowerGeneral).map(
        item => {
            return (<GeneralActionDisplay
                key={item.id}
                item={item}
                character={displayedCharacter}
                generalPools={generalPowerPools}
                setGeneralPools={setGeneralPowerPools}
                isPowers={true}
            />)
        }
    );

    const investigativeAbilityRows
        = data.investigativeAbilities.filter(characterHasInvestigativeAbility).map(
        item => {
            return (<InvestigativeActionDisplay
                key={item.id}
                item={item}
                character={displayedCharacter}
            />)
        }
    );

    const investigativePowerRows
        = data.mutantPowers.filter(shouldDisplayPowerInvestigative).map(
        item => {
                return (<InvestigativeActionDisplay
                key={item.id}
                item={item}
                character={displayedCharacter}
            />)
        }
    );

    // navigation

    const activateButton = (buttonID) => {
        const btns = document.getElementsByClassName("button-selected");
        while (btns.length) {
            btns[0].classList.remove("button-selected");
        }
        const selectBtn = document.getElementById(buttonID);
        selectBtn.classList.add("button-selected");
    }

    function navGeneral() {
        setSelectedMode("DISPLAY_GENERAL");
        activateButton("nav-btn-general");
    }

    function navPowers() {
        setSelectedMode("DISPLAY_POWERS");
        activateButton("nav-btn-powers");
    }

    function navInvestigative() {
        setSelectedMode("DISPLAY_INVESTIGATIVE");
        activateButton("nav-btn-investigative");
    }

    // reset

    const resetPools = (pools, maxPools, setPools) => {
        const copyPools = structuredClone(pools);        
        for (let pool in pools) {
            const maxPoints = maxPools[pool];
            copyPools[pool] = maxPoints;
        }
        setPools(copyPools);
    }

    const resetPushes = () => {
        //TODO: reset pushes
    }

    const resetGeneralPools = (e) => {
        e.preventDefault();
        resetPools(generalAbilityPools,
            displayedCharacter.generalAbilities, setGeneralAbilityPools);
        resetPools(generalPowerPools,
            displayedCharacter.powers, setGeneralPowerPools);
        resetPushes();
    }

    // pdf generation

    const GenerateCharacterSheet = (e) => {
        e.preventDefault();
        const generalPowers = data.mutantPowers.filter(shouldDisplayPowerGeneral);
        return generatePdfDocument(data,
            displayedCharacter,
            displayedCharacter.name,
            generalPowers);
    }

    // pushes

    function togglePush1() {
        const checkbox = document.getElementById("push-toggle-1");
        let updatedPushes = structuredClone(pushes);
        updatedPushes[0] = checkbox.checked ? 1 : 0;
        setPushes(updatedPushes);
    }

    function togglePush2() {
        const checkbox = document.getElementById("push-toggle-2");
        let updatedPushes = structuredClone(pushes);
        updatedPushes[1] = checkbox.checked ? 1 : 0;
        setPushes(updatedPushes);
    }

    // portrait

    function characterPortraitURL() {
        return "MCBP/" + displayedCharacter.portraitName + ".png";
    }

    // power description

    function SelectedPowerDescription() {
        if (parseInt(selectedPowerID) >= 0) {
            var powerData = findPower(selectedPowerID);
            return powerData.description;
        }
        return null;
    }

    // render

    return (
        <div style={{width:"950px"} }>        
            <div className="App-header-topflare">
                <button type="button" className="App-backbutton" onClick={handleCharacterSubmit}>
                    <div className="App-backbuttonicon">
                        <img 
                            src="./backbutton.png"
                            alt="back"
                            width="26px"
                            
                            />
                    </div>
                </button>
                <button type="button" className="App-editbutton" onClick={editCharacter}>
                    <div className="App-editbuttonicon">
                        <img alt="edit"
                            src="./Pencil.png" width="20px"  />
                    </div>
                </button>
            </div>
            <div className="App-header-character-infobox">
                <div className="App-header-charactername">
                    <div className="App-header-characterpicture"
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/' + characterPortraitURL()})` }}>
                    </div>
                    <div className="App-header-characternametext">
                        {displayedCharacter.name}
                    </div>
                </div>               
                <div className = "App-header-characterinfo">
                    <div className="App-header-characterdescription">
                        <div className="App-header-characterdescription-header">
                        Character Description
                        </div>
                        <div className="App-header-characterdescription-whitebar" />
                        <div className="App-header-characterdescription-description">
                            <div className="App-header-characterdescription-description-text">
                                {displayedCharacter.description}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="App-display-character-box">
            <div className="App-blackbar" />
                <nav style={{display:"flex", justifyContent:"center"} }>
                <ul className="App-nav-tabs">
                        <li className="App-nav-tab">
                        <div className = "App-tab-border" />
                            <button id="nav-btn-general"
                                className="button-selected"
                            type="button"
                                onClick={navGeneral}>GENERAL ABILITIES
                            </button>
                        </li>
                        <li className="App-nav-tab" style={{ marginLeft: "-4%", marginRight: "-4%" }}>
                            <div className="App-tab-border" />
                            <button id="nav-btn-investigative"
                                type="button"
                                onClick={navInvestigative}>INVESTIGATIVE ABILITIES
                            </button>
                        </li>
                        <li className="App-nav-tab" >
                            <div className="App-tab-border" />
                            <button id="nav-btn-powers"
                                type="button"
                                onClick={navPowers}>QUADE DIAGRAM
                            </button>
                        </li>
                </ul>
                </nav>
                <form className="App--edit-character-form" onSubmit={handleCharacterSubmit}>
                    {selectedMode === "DISPLAY_GENERAL" && generalAbilityRows.length > 0 && (
                        <div className="App--general-action-box">
                            {hasAnyGeneralAbilities() && (
                            <div>
                                <div className="App--general-action-header" >
                                GENERAL ABILITIES
                                </div>
                                <div className="App--general-action-box-inner">
                                {generalAbilityRows}
                                </div>
                            </div>
                            )}
                            {hasAnyGeneralPowers() && (
                                <div>
                            <div className="App--general-action-header" >
                                GENERAL POWERS
                            </div>
                            
                                <div className="App--general-action-box-inner">
                                    {generalPowerRows}
                                    </div>
                                    </div>
                            )}
                            <div className="App--general-bottom-row">
                                <div className="App--general-export-pdf-button-box">
                                    <button className="App--general-export-pdf-button" onClick={GenerateCharacterSheet}>
                                        Download PDF
                                    </button>
                                </div>
                                <div className="App--general-reset-points-button-box">
                                    <button className="App--general-reset-points-button" onClick={resetGeneralPools}>
                                        Reset Points
                                    </button>
                                </div>
                            </div>
                        </div>
                )}
                    {selectedMode === "DISPLAY_POWERS" && (
                    <div>
                            <Quade
                                powerData={data.mutantPowers}
                                linkData={data.mutantPowerLinks}
                                isEditable={false}
                                powers={displayedCharacter.powers}
                                solidLinks={displayedCharacter.solidLinks}
                                dashedLinks={displayedCharacter.dashedLinks}
                                selectedPowerID={selectedPowerID}
                                setSelectedPowerID={setSelectedPowerID}
                            />
                            {parseInt(selectedPowerID) >= 0 && (
                                <div style={{ marginTop: "20px" }}>
                                    <div className="Symmetrical-topflare"
                                        style={{ fontSize: "20px" }}>
                                    DESCRIPTION
                                    </div>
                                    <div className="Powers--description-container-inner">
                                        <div style={{padding: "16px"} }>
                                            {SelectedPowerDescription()}
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                    )}
                    {selectedMode === "DISPLAY_INVESTIGATIVE" && (
                        <div>
                        {(hasAnyInvestigativeAbilities() || hasAnyInvestigativePowers()) && (
                                <div className="App--general-action-box">
                                    {hasAnyInvestigativeAbilities() && (
                            <div>
                            <div className="App--general-action-header Investigative-header" >
                                <div style={{ flex: "1" }}></div>
                                                <div style={{display:"flex", flexDirection:"row"}}>
                                        <div className="App--investigative-header-text">
                                            INVESTIGATIVE ABILITIES
                                        </div>
                                        <div className="App--investigative-push-section">
                                            <div style={{ marginRight: "8px"}} >
                                                PUSHES
                                            </div>
                                            <div className="App--investigative-push-box">
                                                <input type="checkbox"
                                                    title="Push"
                                                    id="push-toggle-1"
                                                    className="App--investigative-push-checkbox"
                                                    onChange={togglePush1}
                                                    defaultChecked={pushes[0] === 1}
                                                />
                                                <label
                                                    className="App--investigative-push-label"
                                                    htmlFor="push-toggle-1">
                                                    Toggle
                                                </label>
                                            </div>
                                            <div className="App--investigative-push-box">
                                                <input type="checkbox"
                                                    title="Push"
                                                    id="push-toggle-2"
                                                    className="App--investigative-push-checkbox"
                                                    onChange={togglePush2}
                                                    defaultChecked={pushes[1] === 1}
                                                />
                                                <label
                                                    className="App--investigative-push-label"
                                                    htmlFor="push-toggle-2">
                                                    Toggle
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                        </div>
                                    
                            <div className="App--general-action-box-inner">
                                {investigativeAbilityRows}
                                            </div>
                                        </div>
                                    )}
                            {hasAnyInvestigativePowers() && (
                                <div>
                                    <div className="App--general-action-header">
                                        INVESTIGATIVE POWERS
                                    </div>
                                    <div className="App--general-action-box-inner">
                                        {investigativePowerRows}
                                    </div>
                                </div>)}
                           </div>)}
                        </div>
                    )}
            </form>
            </div>
        </div>
    );
}

export default DisplayCharacter;